define('pages/main/register',["jquery", "appquery", "app", "modules/setup"], function($, $$, App, Setup) {
    $$ = $$('register');

    return {
        init : function(data) {
            $$('#registerForm').submit(function(e) {
                e.preventDefault();
                var formData = $(this).serializeObject();
                App.page.render('spinner', 'Please wait while we are registering this device under the name "' + formData.name + '" ...');
                App.api.call('/retailer.registerDevice', formData, function(response) {
                    App.database.set('device_id', response.id).then(function() {
                        App.page.render('message', '<h2>Your device is registered successfully.</h2><p>Set store and location for this device in admin and reload this page.</p>');
                    });
                }, function(message) {
                    App.page.render('message', '<h4>' + message + '</h4><button type="button" class="btn btn-custom back">Go back and try again</button>');
                });
            });
        },
        footer : false,
    };
});
